import { Suspense } from 'react';
import 'swiper/css';
import './assets/boxicons-2.0.7/css/boxicons.min.css';
import './App.scss';
import './components/skeleton/skeleton.scss';
import '@mantine/core/styles.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { MantineProvider } from '@mantine/core';
import { Toaster } from 'react-hot-toast';
import { theme } from './theme';
import Header from './components/header/Header';
import Footer from './components/footer/Footer';
import ScrollToTop from './components/ScrollToTop';
import TopProgressBar from './components/top-progress-bar/TopProgressBar';
import Loading from './components/loading/Loading';
import ChunkErrorBoundary from './components/ChunkErrorBoundary';
import GlobalAds from './components/global-ads/GlobalAds';
import lazyWithRetry from './utils/lazyWithRetry';

// Lazy-loaded route components
const Home = lazyWithRetry(() => import('./pages/home/Home'));
const Catalog = lazyWithRetry(() => import('./pages/Catalog'));
const Detail = lazyWithRetry(() => import('./pages/detail/Detail'));
const Person = lazyWithRetry(() => import('./pages/person/Person'));
const MultiSearch = lazyWithRetry(() => import('./components/MultiSearch/MultiSearch'));
const MyList = lazyWithRetry(() => import('./pages/my-list/MyList'));
const SharedList = lazyWithRetry(() => import('./pages/shared-list/SharedList'));
const Collection = lazyWithRetry(() => import('./pages/collection/Collection'));
const Anime = lazyWithRetry(() => import('./pages/anime/Anime'));

function App() {
    return (
        <MantineProvider theme={theme} defaultColorScheme="dark">
            <BrowserRouter
                future={{
                    v7_startTransition: true,
                    v7_relativeSplatPath: true,
                }}
            >
                <ScrollToTop />
                <TopProgressBar />
                <GlobalAds />
                <Header />
                <ChunkErrorBoundary>
                <Suspense fallback={<Loading />}>
                    <Routes>
                        <Route path='/person/:id' element={<Person />} />
                        <Route path='/collection/:id' element={<Collection />} />
                        <Route path='/anime' element={<Anime />} />
                        <Route path='/my-list' element={<MyList />} />
                        <Route path='/shared-list' element={<SharedList />} />
                        <Route path='/:category/search/:keyword' element={<Catalog />} />
                        <Route path='/:category/type/:type' element={<Catalog />} />
                        <Route path='/:category/:id' element={<Detail />} />
                        <Route path='/:category' element={<Catalog />} />
                        <Route path='/' element={<Home />} />
                        <Route path="/search" element={<MultiSearch />} />
                        <Route path="/search/:keyword" element={<MultiSearch />} />
                    </Routes>
                </Suspense>
                </ChunkErrorBoundary>
                <Footer />
                <Toaster
                    position="top-right"
                    toastOptions={{
                        duration: 3000,
                        style: {
                            background: '#333',
                            color: '#fff',
                        },
                    }}
                />
            </BrowserRouter>
        </MantineProvider>
    );
}

export default App;
